var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCny(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_1779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9453 12.1719L12.6719 17.4844H18.2578L13.7422 20.7734L15.4688 26.0859L10.9453 22.8047L6.42188 26.0859L8.15625 20.7734L3.63281 17.4844H9.21875L10.9453 12.1719Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7109 30.9766L22.3906 29.3516L20.4375 30.1094L21.5703 28.3516L20.25 26.7188L22.2734 27.2578L23.4141 25.5L23.5234 27.5938L25.5547 28.1328L23.5938 28.8828L23.7109 30.9766Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3359 26.2109L26.9609 24.2109L25.25 23L27.3437 22.9688L27.9609 20.9688L28.6406 22.9531L30.7344 22.9297L29.0547 24.1797L29.7266 26.1641L28.0156 24.9531L26.3359 26.2109Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.875 14.6797L28.9531 16.5625L30.4531 18.0234L28.3828 17.7266L27.4609 19.6016L27.1016 17.5391L25.0234 17.2422L26.8828 16.2656L26.5234 14.1953L28.0234 15.6562L29.875 14.6797Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7656 8.97656L23.6094 11.0625L25.5547 11.8516L23.5156 12.3516L23.3672 14.4453L22.2656 12.6641L20.2266 13.1641L21.5781 11.5625L20.4688 9.78906L22.4141 10.5781L23.7656 8.97656Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_1779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCny);
export default __webpack_public_path__ + "static/media/CNY.c89b72d218f3193fb62386c4a7c1ee8d.svg";
export { ForwardRef as ReactComponent };